import { render } from "./FolderDialog.vue?vue&type=template&id=554c59b9"
import script from "./FolderDialog.vue?vue&type=script&lang=js"
export * from "./FolderDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__